import React, { useState } from 'react';

import { If } from 'react-if';

import CloseIcon from '@nerdwallet/react-icon/material/Close';
import { colors } from '@nerdwallet/base-styles/variables';

import { usePlaidFooterInstitutionContext } from '@components/financial-institutions/plaid-sandbox/plaid-footer-institution-context';

import DashboardFooter from '../dashboard-footer/dashboard-footer';
import LinkingInstitutions from '../components/linking-institutions';
import UserActionInstitutions from '../components/user-action-institutions';

import styles from './institutions-footer.module.scss';

export const InstitutionsFooter = () => {
  const [isUserDismissed, setIsUserDismissed] = useState(false);

  const { linkingState, actionRequiredState } =
    usePlaidFooterInstitutionContext();

  const hideFooter = () => {
    setIsUserDismissed(true);
  };

  if (
    isUserDismissed ||
    (!linkingState.isLinking && !actionRequiredState.isActionRequired)
  ) {
    return null;
  }

  return (
    <DashboardFooter>
      <div className={styles.container}>
        <LinkingInstitutions />
        <If condition={!linkingState.isLinking}>
          <UserActionInstitutions />
        </If>
        <CloseIcon
          className={styles.iconButton}
          color={colors['neutral-light']}
          onClick={hideFooter}
          size={16}
        />
      </div>
    </DashboardFooter>
  );
};

export default InstitutionsFooter;
